/**
 * WebEnertia URL Parameters
 * Helper functions for getting and setting URL parameters with arrays
 *
 * @version: 1.0.0
 */

// Set URL parameters to keys and values in object
function setURLParameters(params) {
  // Convert object to string and add question mark if needed
  params = jQuery.param(params);
  if(params.length) params = '?' + params;
  params = params.replace(/\+/g, ' ');
  params = decodeURIComponent(params);

  // Alter window history to change URL without reloading page
  window.history.replaceState({"html":jQuery('html').html(),"pageTitle":document.title},"", document.location.href.replace(document.location.search, '') + params);
}

// Get URL parameters as object
function getURLParameters() {
  // Return object from URL parameter string
  return jQuery.parseParams(window.location.search);
}

/**
 * Parse parameters plugin / snippet
 * Created by Komrod
 * https://gist.github.com/kares/956897#gistcomment-1190642
 */
!function(e){var r=/([^&=]+)=?([^&]*)/g,n=function(e){return decodeURIComponent(e.replace(/\+/g," "))};e.parseParams=function(i){function t(r,n,i){if(-1!==(n+="").indexOf(".")){var s=n.split("."),a=n.split(/\.(.+)?/)[1];r[s[0]]||(r[s[0]]={}),""!==a?t(r[s[0]],a,i):console.warn('parseParams :: empty property in key "'+n+'"')}else if(-1!==n.indexOf("[")){s=n.split("[");n=s[0];var f=(s=s[1].split("]"))[0];""==f?(r||(r={}),r[n]&&e.isArray(r[n])||(r[n]=[]),r[n].push(i)):(r||(r={}),r[n]&&e.isArray(r[n])||(r[n]=[]),r[n][parseInt(f)]=i)}else r||(r={}),r[n]=i}""===(i+="")&&(i=window.location+"");var s,a={};if(i){if(-1!==i.indexOf("#")&&(i=i.substr(0,i.indexOf("#"))),-1===i.indexOf("?"))return{};if(""==(i=i.substr(i.indexOf("?")+1,i.length)))return{};for(;s=r.exec(i);){t(a,n(s[1]),n(s[2]))}}return a}}(jQuery);
